import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { CreateTagInput, TagResponse } from '@orion/contracts';
import { api } from '../../../lib/api-client.js';

export function useTagsQuery() {
  return useQuery({ queryKey: ['tags'], queryFn: () => api.get<TagResponse[]>('/tags') });
}
export function useCreateTag() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateTagInput) => api.post<TagResponse>('/tags', input),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['tags'] }),
  });
}
export function useDeleteTag() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.delete(`/tags/${id}`),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['tags'] }),
  });
}
